import LayoutFooter from "@/components/footer";
import useUpdateImei from "@/services/fcm/hooks/useUpdateImei";
import { Stack } from "@mantine/core";

import useIsSmall from "@/hooks/useIsSmall";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { FullContainer } from "../auth/style";
import DesktopLayout from "./Desktop";
import { RenewModal, SubscriptionBanner } from "@/modules/subscription/SubscriptionNotices";

function DashboardLayout() {
  const { i18n } = useTranslation();
  const isSmall = useIsSmall();
  const { mutate } = useUpdateImei();

  useEffect(() => {
    // const fcm = searchParams.get("fcm");
    const platform = localStorage.getItem("platform");
    if (platform === "android") {
      const imie = localStorage.getItem("imie");
      mutate(imie || "");
    }
  }, [mutate]);

  return isSmall ? (
    <FullContainer dir={i18n.dir()} fluid p={0}>
      {/* <Header /> */}
      {/* <motion.div
  key={pathname}
  initial={{ opacity: 0, x: "100%" }}
  animate={{ opacity: 1, x: 0 }}
  exit={{ opacity: 0, x: "-100%" }}
  transition={{ duration: 0.2 }}
></motion.div> */}
      <Stack h="100svh" m="0" justify="start">
        <Stack
          style={{
            overflow: "hidden",
            overflowY: "auto",
            flexGrow: 1,
            marginBottom: "62px",
          }}
          id="dashboard-layout"
          justify="start"
          gap={0}
        >
          <SubscriptionBanner />
          <Outlet />
        </Stack>
        <RenewModal />
      </Stack>

      <LayoutFooter />
    </FullContainer>
  ) : (
    <DesktopLayout />
  );
}

export default DashboardLayout;
